import(/* webpackMode: "eager", webpackExports: ["About"] */ "/app/features/LandingControl/ui/About/About.tsx");
;
import(/* webpackMode: "eager" */ "/app/features/LandingControl/ui/Welcome/ui/StatsBlock/StatsBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/widgets/Contact/Contact.tsx");
